import { render, staticRenderFns } from "./updateNameFail.vue?vue&type=template&id=01156370"
import script from "./updateNameFail.vue?vue&type=script&lang=js"
export * from "./updateNameFail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports